import { render, staticRenderFns } from "./LogoutGuide.vue?vue&type=template&id=4f4b95e3"
import script from "./LogoutGuide.vue?vue&type=script&lang=js"
export * from "./LogoutGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports